// extracted by mini-css-extract-plugin
export default {"searchitem":"SongSearchItem_searchitem__cw-Ey","days":"SongSearchItem_days__7UKC6"};